export class Escaping {
	public static escapeHtml = (s:string):string => {
		return String(s).replace(/[^\w. ]/gi, function (c){
			return '&#'+c.charCodeAt(0)+';';
		});
	};
}